import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";

type Props = { size?: "sm" | "default"; light?: boolean };

const SUPPORTED = ["es", "en", "de", "it", "fr", "pt"] as const;

export function LanguageSwitcher({ size = "default", light = false }: Props) {
  const { i18n } = useTranslation();

  const current = useMemo(() => {
    const raw = (i18n.resolvedLanguage || i18n.language || "en").toLowerCase();
    const two = raw.split("-")[0];
    return (SUPPORTED as readonly string[]).includes(two) ? two : "en";
  }, [i18n.language, i18n.resolvedLanguage]);

  const onChange = async (lng: string) => {
    try {
      localStorage.setItem("i18nextLng", lng);
    } catch {}
    await i18n.changeLanguage(lng);
    document.documentElement.lang = lng;
  };

  const label = (lng: string) => lng.toUpperCase();

  return (
    <Select value={current} onValueChange={onChange}>
      <SelectTrigger
        size={size}
        className={
          light
            ? "w-[74px] bg-transparent text-black border-black/30"
            : "w-[74px] bg-transparent text-white border-white/30"
        }
      >
        <SelectValue placeholder={label(current)} />
      </SelectTrigger>
      <SelectContent>
        {SUPPORTED.map((lng) => (
          <SelectItem key={lng} value={lng}>
            {label(lng)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}


